var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestmentSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 13.5417V9.375C22.9167 4.16666 20.8333 2.08333 15.625 2.08333H9.375C4.16667 2.08333 2.08334 4.16666 2.08334 9.375V15.625C2.08334 20.8333 4.16667 22.9167 9.375 22.9167H13.5417",
    stroke: "#009100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63541 15.0938L10.1146 11.875C10.4687 11.4167 11.125 11.3334 11.5833 11.6875L13.4896 13.1875C13.9479 13.5417 14.6042 13.4584 14.9583 13.0104L17.3646 9.90627",
    stroke: "#009100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2917 16.4792L20.5833 17.0729C20.7292 17.3646 21.0937 17.6354 21.4167 17.6979L21.8125 17.7604C23 17.9583 23.2812 18.8333 22.4271 19.6979L22.0625 20.0625C21.8229 20.3125 21.6875 20.7917 21.7604 21.125L21.8125 21.3438C22.1354 22.7813 21.375 23.3333 20.125 22.5833L19.8542 22.4271C19.5312 22.2396 19.0104 22.2396 18.6875 22.4271L18.4167 22.5833C17.1562 23.3437 16.3958 22.7813 16.7292 21.3438L16.7812 21.125C16.8541 20.7917 16.7188 20.3125 16.4792 20.0625L16.1146 19.6979C15.2604 18.8333 15.5417 17.9583 16.7292 17.7604L17.125 17.6979C17.4375 17.6458 17.8125 17.3646 17.9583 17.0729L18.25 16.4792C18.8125 15.3438 19.7292 15.3438 20.2917 16.4792Z",
    stroke: "#009100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentSteps);
export default __webpack_public_path__ + "static/media/investment-steps.937108d1ac5a75b0b532f3e36a8bc216.svg";
export { ForwardRef as ReactComponent };